<template>
  <div class="impress impress--container">
    <v-checkbox
      v-model="checkBox"
      label="Global Impressions Limit"
      :disabled="userStore.isReadOnly || isSandboxLocked"
      hideDetails
      class="impress--checkbox"
      @update:modelValue="
        v => {
          if (!isSandboxLocked) props.modelValue.is_limited = v;
        }
      "
    />
    <div v-if="checkBox" class="impress--input-wrapper">
      <RfTextInput
        v-model.trim="props.modelValue.hard_limit"
        variant="outlined"
        title="Limit to"
        density="compact"
        hideDetails
        :readonly="userStore.isReadOnly"
        :disabled="isSandboxLocked"
      />
      <RfTextInput
        v-model.trim="props.modelValue.soft_limit"
        variant="outlined"
        title="Show Warning at"
        density="compact"
        hideDetails
        :readonly="userStore.isReadOnly"
        :disabled="isSandboxLocked"
      />
    </div>
  </div>
</template>

<script setup>
import RfTextInput from "@/components/legacy/RfInputLegacy.vue";
import { useAppsStore } from "@/pinia/appsStore";
import { useUserStore } from "@/pinia/userStore";
import { computed, ref } from "vue";

const props = defineProps(["modelValue"]);
const appsStore = useAppsStore();
const userStore = useUserStore();

const checkBox = ref(!!props.modelValue?.is_limited);

const isSandboxLocked = computed(
  () => appsStore.app?.flags?.sandbox && !userStore.isCurrentSuperAdmin,
);
</script>

<style lang="scss" scoped>
.impress--container {
  display: inline-flex;
  flex-direction: column;
  gap: 16px;

  .impress--input-wrapper {
    margin-left: 30px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    font-weight: 500;
    font-size: 14px;
  }
}
</style>
